import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {push} from 'connected-react-router';

import FormComponent from './FormComponent';
import * as action from '../../actions';
import * as selector from '../../selectors';

const mapStateToProps = state => ({
	form: selector.getReviewForm(state),
});
const mapDispatchToProps = dispatch => bindActionCreators({
	sendReview: action.sendReview.request,
	push,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		form: PropTypes.object,
		sendReview: PropTypes.func,
		push: PropTypes.func,
	};

	onSubmit = (props, onFailure) => {
		const {sendReview, push} = this.props;
		const send = new Promise((resolve, reject) => {
			sendReview({
				form: {
					...props,
					like: 0,
				},
				resolve,
				reject,
			});
		});
		send.then(() => {
			push('/');
		}).catch((error) => {
			console.error('Error occurred:', error);
			onFailure && onFailure();
		});
	};

	render() {
		const {
			form: {loading},
		} = this.props;

		return (
			<div className="review review-form review-dislike">
				<div className="header">Нам правда<br />очень жаль!</div>
				<p>Напишите напрямую директору,<br />что вас не устроило в обслуживании.</p>
				<p>Мы примем меры и постараемся разрешить проблему.</p>
				<hr />
				<FormComponent
					like={false}
					loading={loading}
					onSubmit={this.onSubmit}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/review/Dislike.js